import { Button, Card, Col, Container, Row } from 'react-bootstrap';

import { COLORS } from '../../styles/colors';
import { MyDocuments } from './components/MyDocuments';
import { MyGroup } from './components/MyGroup';
import OAuthService from '../../services/OauthService';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { useMeQuery } from '../../generated/graphql';

const PageContainer = styled(Container)`
    padding: 2rem 0;
`;

const ProfileCard = styled(Card)`
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 2rem;
`;

const ProfileHeader = styled.div`
    background: linear-gradient(135deg, ${COLORS.primary}, ${COLORS.secondary});
    color: ${COLORS.white};
    padding: 1.5rem;
    border-radius: 12px 12px 0 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const UserName = styled.h3`
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

const UserEmail = styled.p`
    margin: 0.5rem 0 0;
    opacity: 0.9;
    font-size: 0.9rem;
`;

const ProfileContent = styled.div`
    padding: 1.5rem;
    background: white;
`;

const SectionTitle = styled.h4`
    color: ${COLORS.textPrimary};
    font-weight: 600;
    margin: 2rem 0 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid ${COLORS.dark};
`;

const LoginButton = styled(Button)`
    background: ${COLORS.primary};
    border-color: ${COLORS.primary};
    padding: 0.5rem 1.5rem;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        background: ${COLORS.dark};
        border-color: ${COLORS.dark};
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const UnauthorizedMessage = styled.div`
    text-align: center;
    padding: 3rem;
    background: ${COLORS.white};
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    h5 {
        color: ${COLORS.textSecondary};
        margin-bottom: 1rem;
    }
`;

type HomeScreenProps = RouteComponentProps;

export const HomeScreen: React.FC<HomeScreenProps> = ({ history }) => {
    const { data, client } = useMeQuery();

    const handleLogin = async () => {
        // Clear any existing auth state
        localStorage.removeItem('token');

        // Store the current URL to return to after login
        localStorage.setItem('returnUrl', window.location.pathname);
        OAuthService.redirectToLogin();
        await client.resetStore();
    };

    if (!data?.me?.email) {
        return (
            <PageContainer>
                <UnauthorizedMessage>
                    <div>
                        <h5>Ви не авторизовані</h5>
                        <LoginButton onClick={handleLogin}>Увійти</LoginButton>
                    </div>
                </UnauthorizedMessage>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <Row>
                <Col>
                    <ProfileCard>
                        <ProfileHeader>
                            <UserName>{data.me.name}</UserName>
                            <UserEmail>{data.me.email}</UserEmail>
                        </ProfileHeader>
                        <ProfileContent>
                            <MyGroup />
                        </ProfileContent>
                    </ProfileCard>

                    <SectionTitle>Ваші документи</SectionTitle>
                    <MyDocuments />
                </Col>
            </Row>
        </PageContainer>
    );
};
